import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Programs from "./pages/Programs";
import Contact from "./pages/Contact";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";
import { ContentProvider } from "./context/ContentContext";

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hakkimizda" element={<About />} />
              <Route path="/hizmetlerimiz" element={<Services />} />
              <Route path="/hizmet/:slug" element={<ServiceDetail />} />
              <Route path="/programlar" element={<Programs />} />
              <Route path="/iletisim" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
          <Toaster position="bottom-right" theme="dark" />
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
